export default __webpack_public_path__ + "static/media/empty_gift_small.21cfe870.svg";